module.exports = __webpack_public_path__ + "static/media/beer.234ef242.jpg";